/* eslint-disable global-require, no-new */

// Reference our components so they get included
import components from '../../../../components';

require('intersection-observer');

// All other imports
//import { webfontLoader } from 'utils/webfontLoader'
// import Observe from 'utils/Observe';
import 'form/Form';
import 'form/JumpList';
import 'toggle/Toggle';
import 'toggle/Trigger';
import 'ui/Collapsible';
import 'focus-visible';
import StickyNavigation from 'ui/StickyNavigation';
import polyfill from '@dotsunited/load-css-polyfill';
import objectFitImages from 'object-fit-images';
import lazySizes from 'lazysizes';

new StickyNavigation();
//webfontLoader()
// new Observe();
polyfill();
objectFitImages();

// lazySizes config
lazySizes.cfg.lazyClass = 'js-lazy';
lazySizes.cfg.loadingClass = 'js-lazy-loading';
lazySizes.cfg.loadedClass = 'js-lazy-loaded';

// Attach components to elements
export const initializeComponents = (context) => {
  const elements = Array.from(context.querySelectorAll('[data-module]:not([data-initialized])'));

  elements.forEach((element) => {
    // Convert dataset to object in a crossbrowser fashion
    const options = JSON.parse(JSON.stringify(element.dataset));

    // Using the dataset as option means you pass your options as data-setting="value" instead of
    // data-options='{"setting":"value"}'

    element.dataset.module.split(',').forEach((path) => {
      const module = path in components ? components[path] : require(path);
      const Component = module.default ? module.default : module;
      new Component(element, options);
    });

    element.setAttribute('data-initialized', 'true');
  });
};
